// extracted by mini-css-extract-plugin
module.exports = {"row":"row__puc-Y","header":"header__2ax38","cell":"cell__zrdIr","amount":"amount__MjCeK","icon":"icon__D2nCI","muted":"muted__ccw7+","tooltip":"tooltip__X9BTp"};